import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
import styled from 'styled-components';

import CircleIcon from './icons/circle_icon';
import HideIcon from 'components/common/icons/fill/hide-fill';

export default class HiddenButton extends React.Component {
  constructor(props) {
    super(props);
    this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
  }
  render() {
    return (
      <CircleIcon viewBox="0 0 25 25" {...this.props}>
        <StyledHideIcon />
      </CircleIcon>
    );
  }
}

const StyledHideIcon = styled(HideIcon)`
  path {
    transform: scale(0.6);
    transform-origin: center;
  }
`;
